
import React from "react";
import styles from "../assets/style.module.css";
import { IProfileWebsite } from "../../../../services";

interface RankingEntry {
    rank: number;
    team: string;
    flag: string;
    country: string;
    game: string;
    wins: number;
    losses: number;
    draws: number;
    points: number;
    form: ("W" | "L" | "D")[];
    isOurs: boolean;
}

export interface AchievementProps {
    website: IProfileWebsite;
}

function Achievement(props: AchievementProps) {

    const { website } = props;
    const [rankGame, setRankGame] = React.useState<string>("Chess");
    const [rankCountry, setRankCountry] = React.useState<string>("All");
    const ACHIEVEMENTS = [
        { year: 2025, title: "Chess Winner", icon: "fa fa-trophy", desc: "Led the team with 8 goals and 11 assists throughout the tournament." },
        { year: 2025, title: "Call Of Duty Mobile MVP", icon: "fa fa-star", desc: "Named the league's most valuable player for the second consecutive season." },
        { year: 2024, title: "Golden Boot", icon: "fa fa-shoe-prints", desc: "Finished as top scorer with 31 goals in a single league season." },
        { year: 2024, title: "Fortnite Champion", icon: "fa fa-medal", desc: "Scored the winning penalty in the final against rivals Dynamo United." },
        { year: 2023, title: "World's Best Player", icon: "fa fa-globe", desc: "Awarded the prestigious Balondor prize by international football federation." },
        { year: 2023, title: "International Cup Winner", icon: "fa fa-medal", desc: "Guided Brazil to glory in the summer international tournament." },
        { year: 2022, title: "U23 World Cup Winner", icon: "fa fa-award", desc: "Scored a hat-trick in the final to become tournament top scorer." },
        { year: 2021, title: "Best Young Player", icon: "fa fa-certificate", desc: "Recognized as the world's best player under 21." },
    ];

    const RANKINGS: RankingEntry[] = [
        { rank: 1, team: "Bayern Fusion", flag: "🇩🇪", country: "Germany", game: "Chess", wins: 22, losses: 3, draws: 5, points: 71, form: ["W", "W", "D", "W", "W"], isOurs: false },
        { rank: 2, team: "Napoli Stars", flag: "🇮🇹", country: "Italy", game: "Chess", wins: 20, losses: 5, draws: 5, points: 65, form: ["W", "L", "W", "W", "D"], isOurs: false },
        { rank: 3, team: website.display_name, flag: "🇧🇷", country: "Brazil", game: "Chess", wins: 19, losses: 4, draws: 7, points: 64, form: ["W", "W", "W", "D", "W"], isOurs: true },
        { rank: 4, team: "Celtic Knights", flag: "🏴󠁧󠁢󠁳󠁣󠁴󠁿", country: "Scotland", game: "Chess", wins: 18, losses: 6, draws: 6, points: 60, form: ["D", "W", "W", "L", "W"], isOurs: false },
        { rank: 5, team: "Sporting FC", flag: "🇵🇹", country: "Portugal", game: "Chess", wins: 17, losses: 7, draws: 6, points: 57, form: ["W", "D", "L", "W", "W"], isOurs: false },
        { rank: 6, team: "Ajax Elite", flag: "🇳🇱", country: "Netherlands", game: "Chess", wins: 16, losses: 8, draws: 6, points: 54, form: ["L", "W", "D", "W", "W"], isOurs: false },
        { rank: 7, team: "Dynamo United", flag: "🇺🇦", country: "Ukraine", game: "Chess", wins: 15, losses: 9, draws: 6, points: 51, form: ["W", "L", "W", "L", "D"], isOurs: false },
        { rank: 8, team: "Porto United", flag: "🇵🇹", country: "Portugal", game: "Chess", wins: 14, losses: 10, draws: 6, points: 48, form: ["D", "D", "W", "L", "W"], isOurs: false },
        { rank: 1, team: website.display_name, flag: "🇧🇷", country: "Brazil", game: "Call Of Duty Mobile", wins: 21, losses: 4, draws: 5, points: 68, form: ["W", "W", "W", "W", "D"], isOurs: true },
        { rank: 2, team: "Real Tigres", flag: "🇲🇽", country: "Mexico", game: "Call Of Duty Mobile", wins: 19, losses: 5, draws: 6, points: 63, form: ["W", "D", "W", "L", "W"], isOurs: false },
        { rank: 3, team: "Sevilla FC", flag: "🇪🇸", country: "Spain", game: "Call Of Duty Mobile", wins: 18, losses: 6, draws: 6, points: 60, form: ["W", "W", "D", "W", "L"], isOurs: false },
        { rank: 4, team: "Fiorentina FC", flag: "🇮🇹", country: "Italy", game: "Call Of Duty Mobile", wins: 16, losses: 7, draws: 7, points: 55, form: ["L", "W", "W", "D", "W"], isOurs: false },
        { rank: 5, team: "Benfica Stars", flag: "🇵🇹", country: "Portugal", game: "Call Of Duty Mobile", wins: 15, losses: 9, draws: 6, points: 51, form: ["W", "D", "L", "W", "W"], isOurs: false },
        { rank: 6, team: "Inter Milan X", flag: "🇮🇹", country: "Italy", game: "Call Of Duty Mobile", wins: 13, losses: 10, draws: 7, points: 46, form: ["D", "L", "W", "D", "W"], isOurs: false },
        { rank: 1, team: "Dynamo United", flag: "🇺🇦", country: "Ukraine", game: "Fortnite", wins: 20, losses: 4, draws: 6, points: 66, form: ["W", "W", "L", "W", "W"], isOurs: false },
        { rank: 2, team: website.display_name, flag: "🇧🇷", country: "Brazil", game: "Fortnite", wins: 18, losses: 6, draws: 6, points: 60, form: ["W", "D", "W", "L", "W"], isOurs: true },
        { rank: 3, team: "Bayern Fusion", flag: "🇩🇪", country: "Germany", game: "Fortnite", wins: 16, losses: 7, draws: 7, points: 55, form: ["L", "W", "W", "D", "W"], isOurs: false },
        { rank: 4, team: "Ajax Elite", flag: "🇳🇱", country: "Netherlands", game: "Fortnite", wins: 14, losses: 9, draws: 7, points: 49, form: ["D", "W", "L", "W", "D"], isOurs: false },
    ];
    const allCountries: string[] = ["All", ...Array.from(new Set(RANKINGS.map((r: RankingEntry) => r.country))).sort()];
    const allGames: string[] = Array.from(new Set(RANKINGS.map((r: RankingEntry) => r.game)));
    const filteredRankings: RankingEntry[] = RANKINGS.filter((r: RankingEntry) => {
        const matchesGame: boolean = r.game === rankGame;
        const matchesCountry: boolean = rankCountry === "All" || r.country === rankCountry;
        return matchesGame && matchesCountry;
    }).sort((a: RankingEntry, b: RankingEntry) => a.rank - b.rank);

    const posClass = (rank: number): string =>
        rank === 1 ? "top1" : rank === 2 ? "top2" : rank === 3 ? "top3" : "";

    return (<>
        {(website.achievement_settings?.show_trophies_graphs) && (<div className={styles["section"]}>
            <div className={styles["sec-line"]} />
            <h1 className={styles["sec-title"]}>My Trophy <em>Room</em></h1>
            <p className={styles["sec-sub"]}>A lifetime of dedication written in silverware</p>
            <div className={styles["ach-grid"]}>
                {ACHIEVEMENTS.map((a) => (
                    <div key={a.title} className={styles["ach-card"]} data-year={a.year}>
                        <div className={styles["ach-big-icon"]}><i className={a.icon} /></div>
                        <div className={styles["ach-card-year"]}>{a.year}</div>
                        <div className={styles["ach-card-title"]}>{a.title}</div>
                        <div className={styles["ach-card-desc"]}>{a.desc}</div>
                    </div>
                ))}
            </div>
        </div>)}

        {(website.achievement_settings?.show_team_trophies_graphs) && (<div className={styles["section"]}>
            <div className={styles["sec-line"]} />
            <h1 className={styles["sec-title"]}>Trophies Won With <em>Teams</em></h1>
            <p className={styles["sec-sub"]}>My valuable contribution result for my teams</p>
            <div className={styles["ach-grid"]}>
                {ACHIEVEMENTS.map((a) => (
                    <div key={a.title} className={styles["ach-card"]} data-year={a.year}>
                        <div className={styles["ach-big-icon"]}><i className={a.icon} /></div>
                        <div className={styles["ach-card-year"]}>{a.year}</div>
                        <div className={styles["ach-card-title"]}>{a.title}</div>
                        <div className={styles["ach-card-desc"]}>{a.desc}</div>
                    </div>
                ))}
            </div>
        </div>)}

        {(website.achievement_settings?.show_leaderboard_trails) && (<div className={styles["section"]}>
            <div className={styles["sec-line"]} />
            <h2 className={styles["sec-title"]}>Programs <em>Rankings</em></h2>
            <p className={styles["sec-sub"]}>Filter by programs and country to see how {website.display_name} stacks up</p>

            <div className={styles["ranking-filters"]}>
                <select
                    className={styles["ranking-select"]}
                    value={rankGame}
                    onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setRankGame(e.target.value)}
                >
                    {allGames.map((g: string) => (
                        <option key={g} value={g}>{g}</option>
                    ))}
                </select>

                <select
                    className={styles["ranking-select"]}
                    value={rankCountry}
                    onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setRankCountry(e.target.value)}
                >
                    {allCountries.map((c: string) => (
                        <option key={c} value={c}>{c === "All" ? "All Countries" : c}</option>
                    ))}
                </select>

                <span style={{ fontSize: "0.78rem", color: "var(--muted)", marginLeft: "auto", flexShrink: 0 }}>
                    {filteredRankings.length} team{filteredRankings.length !== 1 ? "s" : ""}
                </span>
            </div>

            <div className={styles["ranking-table-wrap"]}>
                {filteredRankings.length === 0 ? (
                    <div className={styles["ranking-empty"]}>No teams found for the selected filters.</div>
                ) : (
                    <table className={styles["ranking-table"]}>
                        <thead>
                            <tr>
                                <th style={{ width: "48px" }}>#</th>
                                <th>Team</th>
                                <th className={`${styles["center"]} ${styles["hide-mobile"]}`}>W</th>
                                <th className={`${styles["center"]} ${styles["hide-mobile"]}`}>D</th>
                                <th className={`${styles["center"]} ${styles["hide-mobile"]}`}>L</th>
                                <th className={styles["center"]}>Pts</th>
                                <th className={`${styles["center"]} ${styles["hide-mobile"]}`}>Form</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredRankings.map((entry: RankingEntry, idx: number) => (
                                <tr key={`${entry.team}-${entry.game}-${idx}`} className={entry.isOurs ? styles["our-team"] : ""}>
                                    <td>
                                        <span className={`${styles["rank-pos"]} ${styles[posClass(entry.rank)]}`}>
                                            {(entry.rank >= 1 && entry.rank <= 3) ? (<i className="fa fa-medal" style={{ color: ["#F5C451", "#C0C7D1", "#CD7F32"][entry.rank - 1] }} />) : entry.rank}
                                        </span>
                                    </td>
                                    <td>
                                        <div className={styles["rank-team-cell"]}>
                                            <span className={styles["rank-flag"]}>{entry.flag}</span>
                                            <div>
                                                <div className={styles["rank-team-name"]}>
                                                    {entry.team}
                                                    {entry.isOurs && <span className={styles["rank-ours-badge"]}>US</span>}
                                                </div>
                                                <div className={styles["rank-team-tag"]}>{entry.country}</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td className={`${styles["center"]} ${styles["hide-mobile"]}`}>{entry.wins}</td>
                                    <td className={`${styles["center"]} ${styles["hide-mobile"]}`}>{entry.draws}</td>
                                    <td className={`${styles["center"]} ${styles["hide-mobile"]}`}>{entry.losses}</td>
                                    <td className={styles["center"]}>
                                        <span className={styles["rank-pts"]}>{entry.points}</span>
                                    </td>
                                    <td className={`${styles["center"]} ${styles["hide-mobile"]}`}>
                                        <span style={{ display: "flex", gap: "2px", justifyContent: "center" }}>
                                            {entry.form.map((f: "W" | "L" | "D", i: number) => (
                                                <span key={i} className={`${styles["form-pill"]} ${styles[`form-${f}`]}`}>{f}</span>
                                            ))}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>

            <div style={{ display: "flex", gap: "1.5rem", marginTop: "1rem", flexWrap: "wrap" }}>
                {[["W – Wins", "var(--text)"], ["D – Draws", "var(--text)"], ["L – Losses", "var(--text)"], ["Pts – Points", "var(--gold)"]].map(([label, color]) => (
                    <span key={label} style={{ fontSize: "0.72rem", color: "var(--muted)" }}>
                        <span style={{ color }}>{label}</span>
                    </span>
                ))}
                <span style={{ fontSize: "0.72rem", color: "var(--muted)", marginLeft: "auto" }}>
                    <span style={{ background: "rgba(201,168,76,0.04)", border: "1px solid rgba(201,168,76,0.2)", padding: "0.1rem 0.5rem", borderRadius: "4px", color: "var(--gold)" }}>Highlighted</span>
                    {" = FC Vanguard"}
                </span>
            </div>
        </div>)}
    </>);
}

export default Achievement;